import React, { useRef } from "react";
import {
  Grid,
  withStyles,
  Button,
  withWidth,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import styled from "styled-components";
import { Link } from "react-router-dom";
import ArrowButtonLink from './../../../shared/components/ArrowButtonLink';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "./../../../redux/actions/auth";
import DynamicElement from 'shared/components/DynamicElement'
import useOnScreen from './../../../shared/components/useOnScreen';
import numeral from 'numeral';
import DiamondSideDrawer from './../diamonds/components/DiamondSideDrawer';
import classNames from "classnames";
import { isOtherShape } from 'logged_out/components/diamonds/All';
import getSymbolFromCurrency from 'currency-symbol-map';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { convertToCurrency } from 'shared/functions/priceCalc';
import SmoothCardScrollingHorizontal from 'shared/components/SmoothCardScrolling/Horizontal';
import { useSwipeable } from 'react-swipeable';

const { detect } = require('detect-browser');
const browser = detect();

const styles = (theme) => ({

});

const SectionHeader = styled.h1`
  font-family: MinionPro-Disp;
  font-size: 72px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.8;
  letter-spacing: normal;
  color: #484f57;
  text-align: center;
  padding: 0;
  margin: 0;
  margin-bottom: 48px;
`;

const RectangleInner = (props) => <div {...props}>
  <svg xmlns="http://www.w3.org/2000/svg" id="icon_next" width="58" height="58" viewBox="0 0 58 58">
    <g transform="translate(11 19.001)">
      <g transform="rotate(-90 4.993 4.992)">
        <path id="Trazado_3218" d="M0 0l4.993 5.447L9.985 0" className="cls-1" transform="translate(0 20.474)" />
        <path id="Trazado_3217" d="M0 26V0" className="cls-1" transform="translate(4.994)" />
      </g>
    </g>
  </svg>
</div>;

const Counter = styled.div`
  height: 57px;
  font-family: MinionPro-Disp;
  font-size: 57px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: left;
  color: #ccced3;
  position: absolute;
    right: 50px;
    top: 100px;
`;

const Rectangle = styled(RectangleInner)`
    width: 158px;
    height: 100%;
    opacity: 0.9;
    background-image: linear-gradient(to right,rgba(255,255,255,0) 0%,#ffffff 99%);
    position: absolute;
    top: 0;
    left: ${props => props.side === 'left' ? '0' : 'auto'};
    right: ${props => props.side === 'left' ? 'auto' : '0'};
    transform: rotate(${props => props.side === 'left' ? '180deg' : '0deg'});
    z-index: 1;

    .cls-1{fill:none;stroke:#b08f6e}

    svg{
      stroke-width: 3px;
      cursor: pointer;
      width: 58px;
      height: 58px;
      object-fit: contain;
      margin-left: 12px;
      vertical-align: middle;

      position: absolute;
      bottom: ${props => props.side === 'left' ? 'auto' : '0'};
      top: ${props => props.side === 'left' ? '0' : 'auto'};
      right: 40px;
    }
`;

const Price = styled.div`
  height: 28px;
  font-family: Lato;
  font-size: 23px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.78;
  letter-spacing: normal;
  color: #24272b;
  margin-top: 14px;
  margin-bottom: 14px;

  .text-style-1 {
    font-size: 15px;
  }
`;

const PriceSubTitle = styled.div`
  height: 18px;
  font-family: Lato;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: 2px;
  text-align: center;
  color: #8d9298;
`;

const CallToActionsButtons = styled(Grid)`
  flex-wrap: nowrap;
  transition-duration: 1s;
  opacity: ${props => props.selected ? 1 : 0};
  
  button{
    height: 33px;
    font-family: Lato;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    text-transform: none;
    margin-top: 22px;
    margin-right: 8px;
    margin-left: 8px;
    
    color: #b08f6e;
    background-color: #ffffff;
    border: solid 1px #b6b8bc;

    box-shadow: none;

    &:hover{
      background-color: inherit;
    }

    &.MuiButton-containedSecondary{
      color: #ffffff !important;
      border: solid 1px #b08f6e;
      background-color: #b08f6e;
    }

    &:disabled{
        border: solid 1px #ccced3;
        background-color: #ccced3;
    }
  }
`;

const imgHeight = 120;
const imgHeightSelected = 180;

const useStyles = makeStyles((theme) => ({
  listWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    marginBottom: 86,
  },
  sliderWrapper: {
    marginLeft: 40,
    width: 286
  },
  gridList: {
    flexWrap: "nowrap",
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)",
    overflow: "hidden",
    height: 'auto',
  },
  title: {
    color: theme.palette.primary.light
  },
  titleBar: {
    background: 'transparent',
    position: 'relative',
    top: 'auto',
    left: 'auto',
    textAlign: 'center'
  },
  subtitleBar: {
    height: 'auto',
    marginTop: 10
  },
  gridListTileRoot: {
    /* alignSelf: 'flex-end', */
    height: 'auto !important',
    minWidth: 270, // this fixed the weird width the box gets when there's only one item.
  },
  gridListTile: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  gridListTileImg: {
    width: '100%',
    height: imgHeightSelected,
    objectFit: 'contain',
    transition: theme.transitions.create(["padding-top"], {
      duration: theme.transitions.duration.complex,
      easing: theme.transitions.easing.easeInOut
    }),
    top: 'auto',
    left: 'auto',
    transform: 'none'
  },
  noDecoration: {
    textDecoration: "none !important"
  }
}));

const HenigSlider = withStyles({
  root: {
    color: '#ccced3',
    height: 2,
    width: '100%'
  },
  thumb: {
    height: 2,
    width: 30,
    backgroundColor: '#24272b',
    /* border: '2px solid currentColor', */
    marginTop: 0,
    marginLeft: 0,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
    borderRadius: 0
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 14px)',
    color: 'black'
  },
  track: {
    height: 2,
  },
  rail: {
    height: 2,
  },
})(Slider);

const SliderLabel = styled.span`
  height: 20px;
  font-family: MinionPro-Disp;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  color: #24272b;
`;

function valuetext(value) {
  return `${value}`;
}

function joinHenigArray(d, field) {
  return [d[field][0].From, d[field][1].To].filter(s => s).join(' to ')
}

function mapSpecials(diamondsDocs = [], fxrates = [], ccy) {
  let tileData = diamondsDocs.filter(a => a.WebSpecial);

  let isSpecialOffers = true;

  // if no special offers, load all
  if (tileData.length === 0) {
    tileData = diamondsDocs.filter(d => d.StkCatType === 'Single Item').slice(0, 100);
    isSpecialOffers = false;
  }

  tileData = tileData.map(d => {
    const isParcel = d.StkCatType === 'Multiple Items';
    d.WebSpecial = d.WebSpecial && parseFloat(d.WebSpecial) || 0;
    const price = d.WebSpecial || (isParcel ? d.ppc : d.price) || d.ExWebTotal;
    return {
      ...d,
      price,
      img: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : '.png'}`,
      priceEl: <div className="price">{getSymbolFromCurrency(ccy) + numeral(Math.round(convertToCurrency(price, isParcel, fxrates, ccy))).format('0,0.00').split('.')[0]}.<small className="text-style-1">{numeral(Math.round(convertToCurrency(price, isParcel, fxrates, ccy))).format('0,0.00').split('.')[1]}</small></div>,
      subtitle: <span>{isParcel ? d.size || '-' : `${numeral(d.STWeight).format('0.00')}ct`} | {joinHenigArray(d, 'Colour') || '-'} | {joinHenigArray(d, 'Clarity') || '-'}</span>,
    }
  });

  return {
    isSpecialOffers,
    tileData,
  }
}

const SpecialOffersSection = (props) => {

  const { diamondsDocs = [], ccy, fxrates = [], className } = props;

  const classes = useStyles();
  const [items, setItems] = React.useState([]);
  const [selectedImg, setSelectedImg] = React.useState(0);
  const ref = useRef()
  const isVisible = useOnScreen(ref)

  const [sideDrawerOpen, set_sideDrawerOpen] = React.useState(false);
  const [sideDrawerProps, set_sideDsideDrawerProps] = React.useState({ row: false });

  function onChange(value) {
    if(!items[value - 1]) return;

    // show the selected item by scrolling to it with a smooth animation, 
    // this also keeps the page scroll unchanged. 
    items[value - 1].scrollIntoView({
      behavior: browser.name !== 'safari' ? "smooth" : 'auto',
      inline: "center",
      block: 'nearest',
    });

    setSelectedImg(value - 1);
  }

  const openBag = (row) => {
    props.AuthActions.addToBag(row, () => {
      set_sideDrawerOpen('bag')
      set_sideDsideDrawerProps({ row });
    });
  };
  const closeBag = () => {
    set_sideDrawerOpen(false)
    set_sideDsideDrawerProps(false);
  };

  const { isSpecialOffers, tileData = [] } = mapSpecials(diamondsDocs, fxrates, ccy);

  const handlers = useSwipeable({
    onSwipedLeft: () => onChange(selectedImg + 2),
    onSwipedRight: () => onChange(selectedImg),
    //swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true
  });

  return (
    <div id={props.id} ref={ref} style={{ backgroundColor: "#FFFFFF", position: 'relative', height: '100vh', display: 'flex' }} className={className}>

      <DiamondSideDrawer open={sideDrawerOpen} closeBag={closeBag} {...sideDrawerProps} />

      <div className="lg-p-top" style={{ margin: 'auto', width: '100%' /* fixed issue with wider page than window  */ }}>

        <SectionHeader>
          {isSpecialOffers &&
            <DynamicElement id="5ffa390d586fa2f4d4147a9c">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          }
          {!isSpecialOffers &&
            <DynamicElement id="60076a4c9fe6443b70468f87">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          }
        </SectionHeader>

        <Counter>{`${selectedImg + 1}`.padStart(2, '0')}</Counter>

        <div className={classes.listWrapper} {...handlers}>
          {selectedImg !== 0 &&
            <Rectangle side={'left'} onClick={() => onChange(selectedImg)} />
          }
          <GridList className={classes.gridList} cols={4.2}>
            {tileData.map((tile, k) => (
              <GridListTile
                classes={{ root: classes.gridListTileRoot, tile: classes.gridListTile, imgFullWidth: classes.gridListTileImg, imgFullHeight: classes.gridListTileImg }}
                key={k}
                tabIndex={k}
                ref={(ref) => {
                  items[k] = ref;
                  setItems(items);
                }}
                style={tileData.length === 1 && { margin: '0 auto' }}
              >
                <LazyLoadImage
                  src={(isVisible && tile.img) || ''}
                  draggable={false}
                  alt=""
                  style={{ maxHeight: 200, paddingTop: selectedImg === k ? 0 : imgHeightSelected - imgHeight }}
                  onClick={() => onChange(k + 1)}
                />
                <GridListTileBar
                  title={isSpecialOffers ? <Price>{tile.priceEl}</Price> : props.isAuthorised ? <Price>{tile.priceEl}</Price> : ''}
                  subtitle={<PriceSubTitle>{tile.subtitle}</PriceSubTitle>}
                  classes={{
                    root: classes.titleBar,
                    rootSubtitle: classes.subtitleBar,
                    title: classes.title
                  }}
                />
                <CallToActionsButtons container justify="center" selected={selectedImg === k}>
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={() => openBag(tile)}
                    disabled={!props.isAuthorised}
                  >
                    Add to Basket
                  </Button>

                  <Link to={`/diamonds/${tile._id}/details`} className={classes.noDecoration}>
                    <Button
                      type="button"
                      variant="contained"
                      color="default"
                      onClick={() => { }}
                    >
                      View Details
                    </Button>
                  </Link>
                </CallToActionsButtons>
              </GridListTile>
            ))}
          </GridList>
          {selectedImg !== tileData.length - 1 &&
            <Rectangle side={'right'} onClick={() => onChange(selectedImg + 2)} />
          }
        </div>

        <Grid container alignItems="center">
          <Grid item xs={4}>
            <Grid className={classes.sliderWrapper} container spacing={1} alignItems="center">
              <Grid item>
                <SliderLabel>{`${selectedImg + 1}`.padStart(2, '0')}</SliderLabel>
              </Grid>
              <Grid item xs>
                <HenigSlider
                  defaultValue={1}
                  getAriaValueText={valuetext}
                  aria-labelledby="discrete-slider"
                  valueLabelDisplay="auto"
                  step={1}
                  min={1}
                  max={tileData.length}
                  value={selectedImg + 1}
                  onChange={(e, v) => onChange(v)}
                />
              </Grid>
              <Grid item>
                <SliderLabel>
                  {`${tileData.length}`.padStart(2, '0')}
                </SliderLabel>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={4} align="center">
            <ArrowButtonLink to={`/diamonds/all${isSpecialOffers ? '/specials' : ''}`} label={'View All'} />
          </Grid>
        </Grid>

        <br />

      </div>
    </div>
  );
};


const MobileWrapper = styled.div`
  width: 100%;
  background-color: white;

  .MainText{
    font-size: 55px;
    line-height: 1;
    padding-top: 100px;
    text-align: center;
    margin-bottom: 10px;
  }

  .Counter{
    position: relative;
    top: auto;
    right: auto;
    width: 100%;
    font-size: 45px;
    text-align: right;
    padding-right: 24px;
  }

  .listWrapper{
    .mobileGridListTileRoot{
      min-width: 115px;

      img{
        transition-duration: 1s;
        transition-property: margin-top,max-height,margin-left;
      }
    }
    .mobileGridListTile{
      overflow: unset;
    }
    
    .price{
      font-size: 15px;
      
      small{
        font-size: 11px;
      }
    }
  }
  
`;

const SectionWrapper = (props) => {
  const { diamondsDocs = [], fxrates = [], ccy } = props;
  const classes = useStyles();

  const [selectedImg, setSelectedImg] = React.useState(0);
  const [items, setItems] = React.useState([]);

  const { isSpecialOffers, tileData = [] } = mapSpecials(diamondsDocs, fxrates, ccy);

  const [sideDrawerOpen, set_sideDrawerOpen] = React.useState(false);
  const [sideDrawerProps, set_sideDsideDrawerProps] = React.useState({ row: false });

  function onChange(value) {
    if(!items[value - 1]) return;

    // show the selected item by scrolling to it with a smooth animation, 
    // this also keeps the page scroll unchanged. 
    items[value - 1].scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: 'nearest',
    });

    setSelectedImg(value - 1);
  }

  const openBag = (row) => {
    props.AuthActions.addToBag(row, () => {
      set_sideDrawerOpen('bag')
      set_sideDsideDrawerProps({ row });
    });
  };
  const closeBag = () => {
    set_sideDrawerOpen(false)
    set_sideDsideDrawerProps(false);
  };

  const mobile_imgHeight = 61;
  const mobile_imgHeightSelected = 120;


  const onListScrollEnd = (isEnd) => {
    if(!isEnd) return true;
    console.log('END of LIST')
  }

  const mobileTileData = [...tileData].slice(0, 100);

  if (props.width === 'xs') {
    return <MobileWrapper className="dark-support">
      <SectionHeader className="MainText">
        {isSpecialOffers &&
          <DynamicElement id="5ffa390d586fa2f4d4147a9c">
            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
          </DynamicElement>
        }
        {!isSpecialOffers &&
          <DynamicElement id="60076a4c9fe6443b70468f87">
            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
          </DynamicElement>
        }
      </SectionHeader>

      <div className={classNames(classes.listWrapper, 'listWrapper')} style={{marginBottom: 0, height: 400}}>

        <SmoothCardScrollingHorizontal
          width={'100vw'}
          cardWidth={185}
          cardHeight={330}
          cardMargin={24}
          scrollBarMargin={20}
          highQualityAnimation
          onListScroll={e => onListScrollEnd(e.target.scrollLeft - (e.target.scrollWidth-e.target.clientWidth) === 0)}
          items={mobileTileData.map((tile, k) => (
            <div
              classes={{ root: classNames(classes.gridListTileRoot, 'mobileGridListTileRoot'), tile: classNames(classes.gridListTile, 'mobileGridListTile'), imgFullWidth: classes.gridListTileImg, imgFullHeight: classes.gridListTileImg }}
              key={k}
              tabIndex={k}
              style={{textAlign: 'center', marginLeft: 20 }}
            >
              <LazyLoadImage
                src={(tile.img) || ''}
                draggable={false}
                alt=""
                style={{ maxHeight: mobile_imgHeightSelected, marginTop: 0}}
              />
              <GridListTileBar
                title={isSpecialOffers ? <Price>{tile.priceEl}</Price> : props.isAuthorised ? <Price>{tile.priceEl}</Price> : ''}
                subtitle={<PriceSubTitle>{tile.subtitle}</PriceSubTitle>}
                classes={{
                  root: classes.titleBar,
                  rootSubtitle: classes.subtitleBar,
                  title: classes.title
                }}
                style={{ opacity: 1 }}
              />
              <CallToActionsButtons style={{width: 130, margin: '0 auto' }} container justify="center" direction={'column'} selected={true}>
                <Button
                  type="button"
                  variant="contained"
                  color="secondary"
                  onClick={() => openBag(tile)}
                  disabled={!props.isAuthorised}
                >
                  Add to Basket
                </Button>

                <Link to={`/diamonds/${tile._id}/details`} className={classes.noDecoration}>
                  <Button
                    type="button"
                    variant="contained"
                    color="default"
                    onClick={() => { }}
                    style={{marginTop: 10}}
                  >
                    View Details
                    </Button>
                </Link>
              </CallToActionsButtons>
            </div>
          ))}
        />

  
      </div>
      <Grid item xs={12} align="center" style={{paddingBottom: 50}}>
        <ArrowButtonLink to={`/diamonds/all${isSpecialOffers ? '/specials' : ''}`} label={'View All'} />
      </Grid>
    </MobileWrapper>;
  } else {
    return <SpecialOffersSection {...props} className="dark-support" />
  }
}


export default React.memo(withWidth()(withStyles(styles, { withTheme: true })(connect(
  (state) => ({
    authUser: state.auth.user,
    isAuthorised: state.auth.isAuthorised,
    diamondsDocs: state.diamonds.data && state.diamonds.data.docs || [],
    fxrates: state.site.fxrates,
    ccy: state.site.ccy,
  }),
  (dispatch) => ({
    AuthActions: bindActionCreators({ ...AuthActions }, dispatch)
  })
)(SectionWrapper))));